import React, { useEffect, useState } from "react";
import "./ViewUserForm.css";

const ViewUserForm = ({ selectedUser, transactionHistory, onClose }) => {
  const [voucherHistory, setVoucherHistory] = useState([]);

  useEffect(() => {
    if (selectedUser) {
      fetch(`/api/user-voucher-history/${selectedUser.user_id}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setVoucherHistory(data.history);
          }
        })
        .catch((error) => console.error("Error fetching voucher history:", error));
    }
  }, [selectedUser]);

  if (!selectedUser) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h3>User Details</h3>
        <p><strong>First Name:</strong> {selectedUser.first_name}</p>
        <p><strong>Last Name:</strong> {selectedUser.last_name}</p>
        <p><strong>Email:</strong> {selectedUser.email}</p>
        <p><strong>Phone:</strong> {selectedUser.phone}</p>
        <p><strong>Access Level:</strong> {selectedUser.membership_name}</p>
      </div>
    </div>
  );
};

export default ViewUserForm;
